module.exports = __webpack_public_path__ + "img/logo.6a631ed6.png";